import { render, staticRenderFns } from "./Contrasenha.vue?vue&type=template&id=481efa37&scoped=true"
import script from "./Contrasenha.vue?vue&type=script&lang=js"
export * from "./Contrasenha.vue?vue&type=script&lang=js"
import style0 from "./Contrasenha.vue?vue&type=style&index=0&id=481efa37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481efa37",
  null
  
)

export default component.exports